import { IResult } from '../types/IResponse';
import { Request } from './Request';

export interface CreatePersonalAccessTokenParams {
  clientId: string;
}

export interface CreatePersonalAccessTokenResult  extends IResult {
  refreshToken: string;
}

export class CreatePersonalAccessTokenRequest extends Request<CreatePersonalAccessTokenParams, CreatePersonalAccessTokenResult> {
  constructor(params: CreatePersonalAccessTokenParams) {
    super('createPersonalAccessToken', params);
  }
}
